// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Package40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Package40: FC<Package40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M18.611 33.18V20.793L7.778 14.528v12.389L18.61 33.18Zm2.778 0 10.833-6.263V14.5L21.39 20.792V33.18Zm-2.778 3.195L6.39 29.333a2.717 2.717 0 0 1-1.021-1.013A2.735 2.735 0 0 1 5 26.93V13.07c0-.5.123-.963.368-1.39a2.717 2.717 0 0 1 1.02-1.013l12.223-7.042c.435-.25.898-.375 1.389-.375.49 0 .954.125 1.389.375l12.222 7.042c.435.25.776.588 1.021 1.014.245.426.368.888.368 1.388v13.862c0 .5-.123.962-.368 1.389a2.717 2.717 0 0 1-1.02 1.013l-12.223 7.042c-.435.25-.898.375-1.389.375-.49 0-.954-.125-1.389-.375Zm8.167-21.917 3.903-2.25L20 6.028l-3.917 2.264 10.695 6.166ZM20 18.417l3.972-2.32-10.708-6.18-3.972 2.291L20 18.417Z" />
        </svg>
    );
};

export default Package40;
